import { IndicatorContext } from '@mygpt/app/access/indicator/indicatorProvider';
import { useContext } from 'react';
import { useStore } from 'zustand';
import { shallow } from 'zustand/shallow';

export const useIndicatorContext = () => {
  const context = useContext(IndicatorContext);

  if (!context) {
    throw new Error('useIndicatorContext must be used within IndicatorProvider');
  }

  return context;
};

export const useIndicatorStore = () => {
  const store = useIndicatorContext();

  return useStore(
    store,
    (state) => ({
      close: state.close,
      open: state.open,
      setElement: state.setElement,
    }),
    shallow
  );
};
